export default "__VITE_ASSET__f8c24bd3__"